import * as THREE from 'three';
import BaseMesh from '../BaseMesh.js';
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
class Index extends BaseMesh {
  constructor(data) {
    super(data);
    const { position, zIndex } = data.props;
    const html = this.getHtmlDom(data);
    const label = new CSS2DObject(html);
    // label.position.set(position[0], position[1], position[2]);
    label.position.set(0, 0, position[2]);
    label.layers.set(zIndex);
    this.label = label;
    this.geometry = new THREE.PlaneGeometry(10, 10);
    this.material = new THREE.MeshBasicMaterial({
      transparent: true,
      depthTest: false,
      opacity: 0,
    });
  }
  getLable() {
    return this.label;
  }
  updateProps(key, value) {
    super.updateProps(key, value);
    switch (key) {
      case 'static':
        break;
      case 'text':
        break;
      case 'opacity':
        break;
    }
  }
  getHtmlDom(data) {
    const { text = '', className = '', style = {}, htmlDom = '' } = data.props;
    let html = '';
    if (htmlDom) {
      html = htmlDom;
    } else {
      html = document.createElement('div');
      html.className = className;
      html.textContent = text;
      Object.keys(style).forEach((key) => {
        html.style[key] = style[key];
      });
    }
    return html;
  }
  setProps(props) {

  }
}

export default Index;
